import React, { useEffect } from 'react'
import styles from '../styles.module.scss'
import CustomSelect from '../../../components/CustomSelect'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import { getCLassesByYear, getParallels, getScheduleVariants, getSchoolYears, getShifts, getStudyForms } from '../../../actions/common'
import queryString from 'query-string'
import { useFormik } from 'formik'
import { getSchedule } from '../../../actions/scheduling'
import { getStagesStudy } from '../../../actions/stagesStudy'
import { arrayForSelect } from '../../../utils/arrayForSelect'

const highlightOptions = [
  { name: 'не выделять', value: 'none' },
  { name: 'без преподавателей', value: 'no_teachers' },
  { name: 'без кабинетов', value: 'no_rooms' },
]

export default function Form() {
  const dispatch = useDispatch()
  const { schoolYears, shifts, scheduleVariants, studyForms, parallels, classes } = useSelector(state => state.common)
  const { stageStudyList } = useSelector(state => state.stages_study)

  const navigate = useNavigate()
  const location = useLocation()

  const paramsForm = {}

  const { values, handleChange, setFieldValue } = useFormik({
    initialValues: paramsForm,
  })

  useEffect(() => {
    !schoolYears.length && dispatch(getSchoolYears())
    !shifts && dispatch(getShifts())
    !studyForms && dispatch(getStudyForms())
    !stageStudyList && dispatch(getStagesStudy())
    !parallels && dispatch(getParallels())
    !!values.scYear && !classes && dispatch(getCLassesByYear(values.scYear))
  }, [values.scYear])

  useEffect(() => {
    const searchParams = queryString.stringify(values)
    navigate(`/scheduling?${searchParams}`)
    const { var_id, ...params } = values
    if (!var_id) return
    dispatch(getSchedule(var_id, params))
  }, [values])

  useEffect(() => {
    if (!values.scYear) return
    dispatch(getScheduleVariants(values.scYear))
  }, [values.scYear])

  return (
    <div className={styles.wrapperPanel}>

      <div className={styles.formRow}>
        <div className={styles.rowSelects}>
          <div className={styles.fieldInline}>
            <span className={styles.fieldLabel}>Учебный год</span>
            <CustomSelect
              valuesName="scYear"
              value={values.scYear}
              options={schoolYears && arrayForSelect(schoolYears, 'name', 'xp_key')}
              setFieldValue={setFieldValue}
            />
          </div>
          <div className={styles.fieldInline}>
            <span className={styles.fieldLabel}>Вариант расписания</span>
            <CustomSelect
              valuesName="var_id"
              value={values.var_id}
              options={scheduleVariants && arrayForSelect(scheduleVariants, 'sh_var_name', 'sh_var_id')}
              setFieldValue={setFieldValue}
            />
          </div>
        </div>
        <div className={styles.checkboxGroup}>
          <label className={styles.checkboxLabel}>
            <input type="checkbox" name="editByDate" onChange={handleChange} checked={!!values.editByDate} />
            Редактировать расписание на дату
          </label>
          <label className={styles.checkboxLabel}>
            <input type="checkbox" name="showTeachers" onChange={handleChange} checked={!!values.showTeachers} />
            Показать преподавателей
          </label>
        </div>
      </div>

      <div className={styles.formRow}>
        <div className={styles.rowSelects}>
          <div className={styles.fieldInline}>
            <span className={styles.fieldLabel}>Форма обучения</span>
            <CustomSelect
              valuesName="f_studyform"
              value={values.f_studyform}
              options={studyForms && arrayForSelect(studyForms, 'name', 'f_studyform')}
              setFieldValue={setFieldValue}
            />
          </div>
          <div className={styles.fieldInline}>
            <span className={styles.fieldLabel}>Ступень обучения</span>
            <CustomSelect
              valuesName="f_studysteps"
              value={values.f_studysteps}
              options={stageStudyList && arrayForSelect(stageStudyList, 'name', 'f_studysteps')}
              setFieldValue={setFieldValue}
            />
          </div>
          <div className={styles.fieldInline}>
            <span className={styles.fieldLabel}>Смена</span>
            <CustomSelect
              valuesName="shift"
              value={values.shift}
              options={shifts && arrayForSelect(shifts, 'name', 'sid')}
              setFieldValue={setFieldValue}
            />
          </div>
        </div>
      </div>

      <div className={styles.formRow}>
        <div className={styles.rowSelects}>
          <div className={styles.fieldInline}>
            <span className={styles.fieldLabel}>Параллель</span>
            <CustomSelect
              valuesName="parallel"
              value={values.parallel}
              options={parallels && arrayForSelect(parallels, 'kurs_name', 'year')}
              setFieldValue={setFieldValue}
            />
          </div>
<div className={styles.fieldInline}>
            <span className={styles.fieldLabel}>Выделять ячейки</span>
            <CustomSelect
              valuesName="highlight"
              value={values.highlight}
              options={highlightOptions}
              withoutAll
              setFieldValue={setFieldValue}
            />
          </div>
        </div>
      </div>

    </div>
  )
}
